/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import PropTypes from 'prop-types';
import Control from '../Control/Control';
import CheckedIcon from './ic_done_black_24dp_2x.png';
import './Checkbox.css';

/**
 * Represents the checkbox component.
 */

export default class Checkbox extends Control {
    
    /**
     * Properties.
     */

    static propTypes = {
        checked:        PropTypes.bool,
        index:          PropTypes.number,
        disabled:       PropTypes.bool,
        tooltip:        PropTypes.string,
        onChecked:      PropTypes.func
    }

    /**
     * Default state.
     */

    state = { 
        checked:        this.props.checked
    }

    /**
     * Event that fires when the user clicks to the checkbox.
     */

    toggle = () => {

        // Does the checkbox enabled?

        if (!this.props.disabled) {

            // Setting the new checked state

            let newValue = !this.state.checked;
            this.setValue(newValue);

            // Callbacking the "onChecked" event

            if (this.props.onChecked) {
                this.props.onChecked(newValue, this.props.index);
            }
        }
    }
    
    /**
     * Gets the value of the checkbox.
     * 
     * @return  {Boolean}   checked     checked state of the checkbox
     */

    getValue = () => {
        let value = this.state.checked;

        return value === undefined ? false : value;
    }

    /**
     * Sets the value of the checkbox.
     * 
     * @param   {Boolean}   value       value of the new checked state
     */

    setValue = (value) => {
        this.setState({ checked: value });
    }

    /** 
     * Checkbox renderer.
     */

    render() {
        return (
            <div className={`checkbox ${this.props.disabled ? 'checkbox-disabled' : 'checkbox-enabled' } horizontal vertical center center-justified`} style={this._getStyle()} title={this.props.tooltip} onClick={this.toggle}>
                <img alt="Checked" src={CheckedIcon} className="checkbox-checked" style={{ opacity: this.state.checked ? (this.props.disabled ? 0.2 : 1) : 0 }} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.js